var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"illustration"},[_c('svg-icon',{attrs:{"name":"warn","width":24,"height":24}})],1),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('an-link',{attrs:{"href":_vm.url,"target":"_blank","variant":"secondary"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.ctaText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }